import React from 'react';
import { useRouteError } from 'react-router-dom';
import ErrorPage from '../../components/reusable/ErrorPage/ErrorPage';

const ChunkErrorPage: React.FC = () => {
  const error = useRouteError();
  return <ErrorPage error={error} />;
};

export default ChunkErrorPage;
